import { FormValidationFunction } from "@/views/interfaces/vuetify/form.interface";

export default class CreateAuditForm {
  public date: string = '';
  public shift: string = '';
  public components: number[] = [];
  public ticket: string = '';
  public time: number;

  public baseRules: { [key: string]: FormValidationFunction[] } = {
    ticket: [
      (v: string) => !!v || 'Ticket is required',
      (v: string) => v.length <= 8 || 'Ticket can be at most 8 characters',
      (v: string) => v.includes('-') || 'Ticket is missing a dash',
      (v: string) => (/^[a-zA-Z]{3}-\d{3,4}$/).test(v) || 'Ticket must start with three letters, followed by a dash, and then 3 or 4 numbers',
    ],
    time: [
      (v: string) => !!v || 'Time is required',
      (v: string) => /^\s*[1-9]\d*\s*$/i.test(v) || 'Time must be an integer without leading zeros',
      (v: string) => parseInt(v.trim()) <= 8 || 'Time can be at most 8',
    ],
  };

  public get rules() {
    if (this.shift !== 'WORK') {
      return {
        ticket: [] as any[],
        time: [] as any[],
      };
    }

    return this.baseRules;
  }
}
